import styled from 'styled-components';
import { DeviceType } from '@/utils/definitions';

export interface EditorLayoutProps {
  device: DeviceType;
  previewLoading: boolean;
  alignPreviewRight?: boolean;
}

export const EditorWrapper = styled.div`
  && {
    background: ${(props: EditorLayoutProps) =>
      props.alignPreviewRight ? `white` : `#f8f9fb`};
    overflow: hidden;
    display: grid;
    grid-template-columns: ${(props: EditorLayoutProps) => {
      if (props.alignPreviewRight) {
        return props.device === DeviceType.Desktop ? `1fr 2fr` : `1.5fr 1fr`;
      }
      return props.device === DeviceType.Desktop ? `2fr 1fr` : `1fr 1.5fr`;
    }};
    grid-template-areas: ${(props: EditorLayoutProps) =>
      props.alignPreviewRight ? `'inspector device'` : `'device inspector'`};

    ${(props: EditorLayoutProps) =>
      props.previewLoading ? `cursor: wait;` : ``}

    * {
      ${(props: EditorLayoutProps) =>
        props.previewLoading ? `pointer-events: none;` : ``}
    }
  }
`;

export const EditorDeviceSection = styled.div`
  && {
    grid-area: device;
    height: 100vh;
    min-height: 72rem;
    background: ${(props: { alignPreviewRight?: boolean }) =>
      props.alignPreviewRight ? `white` : `#f8f9fb`};
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 2rem 0;
  }
`;

export const EditorInspectorSection = styled.div`
  && {
    background: white;
    position: relative;
    grid-area: inspector;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: hidden;
    max-height: 100vh;
    min-height: 100vh;
    border-radius: ${(props: { alignPreviewRight?: boolean }) =>
      props.alignPreviewRight ? `0` : `3.5rem 0 0 3.5rem`};
    box-shadow: ${(props: { alignPreviewRight?: boolean }) =>
      props.alignPreviewRight
        ? `none`
        : `0 8px 14px 0 rgba(0, 0, 0, 0.03),
      0 18px 26px 0 rgba(177, 217, 203, 0.04), 0 1px 7px 0 rgba(0, 0, 0, 0.03)`};
  }
`;
